<div class="mb-5x">
  <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.KONZERN.TITEL' | translate }}</h2>
  <common-ui-konzern [(data)]="data" [readonly]="readonly"></common-ui-konzern>
</div>
